import { useEffect, useRef, useState } from "react"
import type { Dispatch, MutableRefObject } from "react"

export function useCallbackSafeState<T>(initialValue: T): [() => T, Dispatch<React.SetStateAction<T>>] {
  const [value, setValue] = useState<T>(initialValue)
  const ref: MutableRefObject<T> = useRef<T>(initialValue)
  ref.current = value

  return [() => ref.current, setValue]
}

export function useCallbackSafeProps<T>(initialValue: T): [() => T] {
  const [value, setValue] = useState<T>(initialValue)
  const ref: MutableRefObject<T> = useRef<T>(initialValue)
  ref.current = value

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  return [() => ref.current]
}
